import { PeriodsChartEnum } from '@helpers/enums';

interface IDateRange {
  label: string;
  value: PeriodsChartEnum;
  type: string;
  startDate: string;
  endDate: string;
}
export interface IHomeFilters {
  dates: IDateRange;
}

class HomeFiltersClass implements IHomeFilters {
  dates: IDateRange;

  constructor(dates: IDateRange) {
    this.dates = dates;
  }
}

export default HomeFiltersClass;
